<div
  [formGroup]="form"
  class="default-form">
  <div class="wrapper">
    <mat-form-field class="ais-product-select">
      <mat-label>AIS product request</mat-label>
      <mat-select
        formControlName="aisProduct"
        (selectionChange)="onAisProductChange($event)">
        @for (product of aisProducts; track product) {
          <mat-option
            [value]="product.value"
            [disabled]="product.value === 'not-sure' || (formReadonly() && fc.aisProduct.value !== product.value)"
            >{{ product.label }}</mat-option
          >
        }
      </mat-select>
    </mat-form-field>

    <!-- Temporality Type Selection -->
    <div class="temporality-type-selector">
      <mat-selection-list
        formControlName="temporality"
        #temporalitySelection
        [multiple]="false">
        @for (type of temporalities; track $index) {
          <mat-list-option
            #temporalityOpt
            class="temporality-type-option"
            [value]="type.value"
            [disabled]="type.disableOn.includes(selectedAisProduct.value)"
            [matTooltip]="type.subtitle"
            togglePosition="before">
            <div class="temporality-type-option-title">
              {{ type.label }}
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>

    <!-- Title -->
    @if (isNOTAM) {
      <ng-container [ngTemplateOutlet]="titleFieldTpl"></ng-container>
    }

    <!-- NOTAM Types (only show when user select AIS Product: NOTAM) -->
    @if (fc.aisProduct.value === aisProductEnum.NOTAM) {
      <div class="notam-type-selector">
        <mat-selection-list
          formControlName="notamType"
          #notamType
          [multiple]="false">
          @for (type of notamTypes; track $index) {
            <mat-list-option
              #notamTypeOpt
              [matTooltip]="type.subtitle"
              [disabled]="(formReadonly() || formDisabled()) && type.value !== fc.notamType.value[0]"
              class="notam-type-option"
              [value]="type.value"
              togglePosition="before">
              <div class="notam-type-option-title">
                {{ type.label }}
              </div>
              <!-- <div class="notam-type-option-subtitle">
            {{ type.subtitle }}
          </div> -->
            </mat-list-option>
          }
        </mat-selection-list>
      </div>

      @if (fc.notamType.value[0] !== "N") {
        <div style="display: flex; gap: 1rem">
          <!-- Referred Series -->
          <mat-form-field style="flex: 1">
            <mat-label>Referred Series*</mat-label>
            <input
              [readonly]="formReadonly()"
              formControlName="referredSeries"
              type="text"
              matInput />
            @if (fc.referredSeries.hasError("required")) {
              <mat-error>Referred Series is required</mat-error>
            }
            @if (fc.referredSeries.hasError("uppercaseLetter")) {
              <mat-error> Must be a single uppercase letter (A-Z) </mat-error>
            }
          </mat-form-field>
          <!-- Referred Number -->
          <mat-form-field style="flex: 1">
            <mat-label>Referred Number*</mat-label>
            <input
              [readonly]="formReadonly()"
              formControlName="referredNumber"
              type="number"
              matInput />
            @if (fc.referredNumber.hasError("required")) {
              <mat-error>Referred number is required</mat-error>
            }
            @if (fc.referredNumber.hasError("positiveNumber")) {
              <mat-error> Must be a positive number </mat-error>
            }
          </mat-form-field>
          <!-- Referred Year -->
          <mat-form-field style="flex: 1">
            <mat-label>Referred Year*</mat-label>
            <input
              [readonly]="formReadonly()"
              formControlName="referredYear"
              type="text"
              matInput />
            @if (fc.referredYear.hasError("required")) {
              <mat-error>Referred Year is required</mat-error>
            }
            @if (fc.referredYear.hasError("invalidYear")) {
              <mat-error>Must be 4-digit year (YYYY) </mat-error>
            }
          </mat-form-field>
        </div>
      }

      <!-- FIR/Aerodrome/Airfield-->
      <div
        class="fir-aerodrome-airfield-wrapper"
        [class.include-wrapper]="fc.aisProduct.value === aisProductEnum.NOTAM">
        <div class="notam-item-fields-wrapper">
          <button
            mat-mini-fab
            class="mat-elevation-z0 notam-item">
            A
          </button>
          <!-- <span>FIR / Aerodrome / Airfield</span> -->
        </div>
        <mat-form-field>
          <mat-label>FIR/Aerodrome/Airfield*</mat-label>
          <input
            [readonly]="formReadonly()"
            appInputTextUppercase
            type="text"
            formControlName="firAerodromeAirfield"
            matInput />
          @if (fc.firAerodromeAirfield.hasError("required")) {
            <mat-error>FIR/Aerodrome/Airfield is required</mat-error>
          }
          @if (fc.firAerodromeAirfield.hasError("fourUppercaseLetters")) {
            <mat-error>Must be 4 uppercase letters</mat-error>
          }
        </mat-form-field>
      </div>
    }

    <!-- AIRAC & Double AIRAC Selection -->
    @if (isAMDT || isSUP) {
      <section class="airac-types-selection">
        <mat-selection-list
          formControlName="airacType"
          [multiple]="false">
          @for (type of airacTypes; track $index) {
            @if (type.displayOn.includes(selectedAisProduct.value)) {
              <mat-list-option
                class="airac-type-option"
                [value]="type.value"
                [disabled]="fc.airacType.value[0] !== type.value && isEdit()"
                togglePosition="before">
                <div class="airac-type-option-title">
                  <span>{{ type.label }}</span>
                </div>
                @if (type.value === "DOUBLE_AIRAC") {
                  <div class="airac-type-option-subtitle double-airac">(major operational changes)</div>
                }
                <div class="airac-type-option-subtitle">
                  Minimum notice:
                  {{
                    type.value === "AIRAC" && isAMDT
                      ? (amdtNoticePeriod | async)
                      : type.value === "AIRAC" && isSUP
                        ? (supNoticePeriod | async)
                        : type.value === "NON_AIRAC"
                          ? (amdtNonAiracNoticePeriod | async)
                          : (amdtDoubleNoticePeriod | async)
                  }}
                  Days
                </div>
              </mat-list-option>
            }
          }
        </mat-selection-list>
      </section>
    }

    <!-- Endof AMDT related fields -->

    <!-- Effective Date -->
    <div
      class="date-wrapper"
      [class.include-wrapper]="fc.aisProduct.value === aisProductEnum.NOTAM">
      @if (fc.aisProduct.value === aisProductEnum.NOTAM) {
        <div class="notam-item-fields-wrapper">
          <button
            mat-mini-fab
            class="mat-elevation-z0 notam-item">
            B
          </button>
        </div>
      }
      <div class="grid-3col">
        <mat-form-field>
          <mat-label>Effective Date*</mat-label>
          <app-custom-datepicker-tz
            #effDatePicker
            formControlName="effectiveDate"
            [readonly]="formReadonly()"
            [minDate]="validDate"
            [dateFilter]="applyAiracDateFilter ? airacDateFilter : null"
            [startAt]="applyAiracDateFilter ? startAt : null"
            [displayAiracDates]="true"
            [timezone]="fc.timezone.value"
            (dateChange)="onEffDateChange($event)"></app-custom-datepicker-tz>
          @if (fc.effectiveDate.enabled) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="!fc.effectiveDate.value ? effDatePicker.openOverlay() : fc.effectiveDate.setValue(null)">
              <mat-icon>{{ !fc.effectiveDate.value ? "today" : "close" }}</mat-icon>
            </button>
          }
          @if (fc.effectiveDate.hasError("required")) {
            <mat-error>Effective date is required</mat-error>
          }
          @if (fc.effectiveDate.hasError("invalidEffDate")) {
            <mat-error>Effective date is not valid</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="time-field">
          <mat-label>Time</mat-label>
          <input
            [readonly]="formReadonly()"
            matInput
            type="time"
            formControlName="effectiveTime"
            [value]="fc.effectiveDate?.value | dateTz: 'HH:mm' : fc.timezone.value"
            [disabled]="!fc.effectiveDate.value || fc.effectiveDate.disabled"
            (change)="onTimeChange($event, 'effectiveDate')" />
          @if (fc.effectiveTime.hasError("pastTime")) {
            <mat-error>Selected time cannot be in the past</mat-error>
          }
        </mat-form-field>
        @if (timezonePreferences | async) {
          <mat-form-field class="timezone-field">
            <mat-label>Timezone</mat-label>
            <app-timezone-select
              [timezonePreferences]="timezonePreferences | async"
              [disableControl]="fc.effectiveDate.disabled"
              formControlName="timezone"></app-timezone-select>
          </mat-form-field>
        }
      </div>
    </div>

    <!-- Due Date -->
    @if (dueDate && displayDueDateSection()) {
      <div class="full-span">
        <mat-card
          appearance="outlined"
          class="due-date-card">
          <mat-card-header>
            <mat-card-title>Due Date</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            @if (this.fc.effectiveDate.hasError("invalidEffDate")) {
              <span>-</span>
            } @else {
              {{ dueDate }}
            }
          </mat-card-content>
        </mat-card>
      </div>
    }

    <!-- Cancel Date -->
    @if (isTemporary) {
      <div
        class="date-wrapper"
        [class.include-wrapper]="fc.aisProduct.value === aisProductEnum.NOTAM">
        @if (fc.aisProduct.value === aisProductEnum.NOTAM) {
          <div class="notam-item-fields-wrapper">
            <button
              mat-mini-fab
              class="mat-elevation-z0 notam-item">
              C
            </button>
          </div>
        }
        <div class="grid-3col">
          <mat-form-field>
            <mat-label
              >Cancel Date
              @if (fc.aisProduct.value === aisProductEnum.NOTAM) {
                <span>*</span>
              }
            </mat-label>
            <app-custom-datepicker-tz
              #cancelDatePicker
              formControlName="cancelDate"
              [readonly]="formReadonly()"
              [minDate]="fc.effectiveDate.value"
              [displayAiracDates]="true"
              [timezone]="fc.timezone.value"
              (dateChange)="onCancelDateChange()"></app-custom-datepicker-tz>
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="!fc.cancelDate.value ? cancelDatePicker.openOverlay() : fc.cancelDate.setValue(null)">
              <mat-icon>{{ !fc.cancelDate?.value ? "today" : "close" }}</mat-icon>
            </button>
            @if (fc.cancelDate.hasError("required")) {
              <mat-error> Cancel date is required </mat-error>
            }
            @if (fc.cancelDate.hasError("invalidCancelDate")) {
              <mat-error>Must not be less to effective date</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="time-field">
            <mat-label>Time</mat-label>
            <input
              [readonly]="formReadonly()"
              matInput
              type="time"
              (change)="onTimeChange($event, 'cancelDate')"
              [value]="fc.cancelDate?.value | dateTz: 'HH:mm' : fc.timezone.value"
              formControlName="cancelTime"
              [disabled]="!fc.cancelDate.value" />
            @if (fc.cancelTime.hasError("pastTime")) {
              <mat-error>Must not be less or equal to effective time</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="timezone-field">
            <mat-label>Timezone</mat-label>
            <app-timezone-select
              formControlName="timezone"
              [timezonePreferences]="timezonePreferences | async"></app-timezone-select>
          </mat-form-field>
        </div>
      </div>
    }
    @if (isNOTAM) {
      <div class="estimated">
        <mat-checkbox
          formControlName="estimated"
          class="example-margin"
          >Estimated</mat-checkbox
        >
      </div>
    }

    <!-- Notam Text -->
    @if (isNOTAM) {
      <div
        class="notam-text-wrapper"
        [class.include-wrapper]="isNOTAM">
        <div class="notam-item-fields-wrapper">
          <button
            mat-mini-fab
            class="mat-elevation-z0 notam-item">
            E
          </button>
          <!-- <span>NOTAM Text</span> -->
        </div>
        <mat-form-field>
          <mat-label>NOTAM Text*</mat-label>
          <textarea
            matInput
            appInputTextUppercase
            [readonly]="formReadonly()"
            formControlName="notamText"
            rows="4"></textarea>
          @if (fc.notamText.hasError("required")) {
            <mat-error>Notam text is required</mat-error>
          }
          @if (fc.notamText.hasError("pattern")) {
            <mat-error>Contains invalid characters </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Lower & Upper Limit -->
      <div class="grid grid-2col">
        <div
          class="lower-limit-wrapper"
          [class.include-wrapper]="isNOTAM">
          <div class="notam-item-fields-wrapper">
            <button
              mat-mini-fab
              class="mat-elevation-z0 notam-item">
              F
            </button>
          </div>
          <mat-form-field>
            <mat-label>Lower Limit</mat-label>
            <input
              [readonly]="formReadonly()"
              appInputTextUppercase
              matInput
              formControlName="lowerLimit" />
            @if (!!lowerLimitError && (fc.lowerLimit.dirty || fc.lowerLimit.touced)) {
              <mat-error>{{ lowerLimitError }}</mat-error>
            }
            <mat-hint
              >A number (max. 5 digits) followed by FT or M and AGL or AMSL; or FL and 3 digits; or SFC or GND.
            </mat-hint>
          </mat-form-field>
        </div>
        <div
          class="upper-limit-wrapper"
          [class.include-wrapper]="isNOTAM">
          <div class="notam-item-fields-wrapper">
            <button
              mat-mini-fab
              class="mat-elevation-z0 notam-item">
              G
            </button>
            <!-- <span>Upper Limit</span> -->
          </div>
          <mat-form-field>
            <mat-label>Upper Limit</mat-label>
            <input
              [readonly]="formReadonly()"
              appInputTextUppercase
              matInput
              formControlName="upperLimit" />
            @if (!!upperLimitError && (fc.upperLimit.dirty || fc.upperLimit.touced)) {
              <mat-error>{{ upperLimitError }}</mat-error>
            }
            <mat-hint
              >A number (max. 5 digits) followed by FT or M and AGL or AMSL; or FL and 3 digits; or UNL.
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    }

    <!-- Tite -->
    @if (!isNOTAM) {
      <ng-container [ngTemplateOutlet]="titleFieldTpl"></ng-container>
    }
    <ng-template #titleFieldTpl>
      <div class="full-span">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input
            [readonly]="formReadonly()"
            matInput
            formControlName="name"
            placeholder="Enter title" />
          <mat-error *ngIf="fc.name.hasError('required')">Title is required</mat-error>
        </mat-form-field>
      </div>
    </ng-template>
    <div></div>
    <!-- Description -->
    <div class="full-span">
      <mat-form-field>
        <textarea
          matInput
          [readonly]="formReadonly()"
          formControlName="description"
          placeholder="Enter description"
          rows="4"></textarea>
      </mat-form-field>
    </div>

    <!-- Attachment -->
    <div class="full-span">
      <mat-card
        appearance="outlined"
        class="attachments-card">
        <mat-card-header>
          <mat-card-title>
            <span>Attachments</span>
            <input
              type="file"
              #fileInput
              ng2FileSelect
              [uploader]="uploader"
              multiple
              hidden />
            @if (!formReadonly() && !formDisabled()) {
              <button
                mat-icon-button
                matTooltip="Add attachments"
                color="primary"
                (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
              </button>
            }
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <!-- NO ATTACHMENTS -->
          @if (!uploader.queue.length && !uploadedFiles.length && !filesToBeDeleted.length) {
            <div class="no-attachment-container">
              <mat-icon>info</mat-icon>
              <span> No attachments</span>
            </div>
          }
          <!-- UNSAVED CHANGES -->
          @if (uploader.queue.length || filesToBeDeleted.length) {
            <!-- Title -->
            @if (isEdit) {
              <div class="attachment-changes-header">Unsaved Changes</div>
            }
            <!-- Uploader Attachments -->
            @for (item of uploader.queue; track item) {
              <div class="attachment-item">
                <div class="file-name">
                  <label>{{ item?.file?.name }}</label>
                </div>

                <button
                  mat-icon-button
                  color="warn"
                  (click)="item.remove()">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
            <!-- Temp Deleted Attachments -->
            @for (file of filesToBeDeleted; track $index) {
              <div class="attachment-item deleted">
                <div class="file-name">
                  <label style="text-decoration: line-through">{{ file }} </label>
                </div>
                <button
                  type="button"
                  mat-icon-button
                  matTooltip="Undo deleted Attachment(s)"
                  (click)="restoreDeletedAttachment(file)">
                  <mat-icon>undo</mat-icon>
                </button>
              </div>
            }
          }
          <!-- CURRENT ATTACHMENTS -->
          @if (uploadedFiles.length) {
            @if (isEdit) {
              <div class="attachment-changes-header">Current Attachments</div>
            }
            @for (file of uploadedFiles; track file) {
              <div class="attachment-item">
                <div
                  class="file-name"
                  (click)="downloadAttachement(file)">
                  <label>{{ file }}</label>
                </div>
                @if (!formReadonly() && !formDisabled()) {
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="deleteCurrentAttachment(file)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            }
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
